import BlogPresenter from './BlogPresenter';

const BlogContainer = () => {
  return <BlogPresenter />;
};

export default BlogContainer;
